import React from 'react';
import { bool, shape, string } from 'prop-types';

const ChevronLeftColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.7782 12.4425L8.3432 9L11.7782 5.5575L10.7207 4.5L6.2207 9L10.7207 13.5L11.7782 12.4425Z" fill="currentColor" />
  </svg>
);

ChevronLeftColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default ChevronLeftColor;
